import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  REGIONES,
  COMUNAS,
  NACIONALIDADES,
  ESTADOS_CIVILES,
  GENEROS,
  DIAS_PAGO,
  ESTADO_CUENTA_OPTIONS,
} from './data/step-five';

@Component({
  selector: 'app-step-five',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './step-five.component.html',
  styleUrls: ['./step-five.component.scss']
})
export class StepFiveComponent {
  @Input() diaPago: string = '';
  @Output() diaPagoChange = new EventEmitter<string>();

  // Constantes
  REGIONES = REGIONES;
  COMUNAS = COMUNAS;
  NACIONALIDADES = NACIONALIDADES;
  ESTADOS_CIVILES = ESTADOS_CIVILES;
  GENEROS = GENEROS;
  DIAS_PAGO = DIAS_PAGO;
  ESTADO_CUENTA_OPTIONS = ESTADO_CUENTA_OPTIONS;

  // Valores por defecto
  region: string = 'metropolitana';
  comuna: string = 'macul';
  calle: string = 'AVENIDA MACUL';
  numero: string = '1234';
  depto: string = 'AVENIDA MACUL';
  nacionalidad: string = 'chilena';
  estadoCivil: string = 'soltero';
  genero: string = 'masculino';
  estadoCuenta: string = 'email';

  onDiaPagoChange(value: string) {
    this.diaPagoChange.emit(value);
  }
} 